<template>
  <div>
    <span
      class="toggle-wrapper"
      role="checkbox"
      :aria-checked="modelValue.toString()"
      @click.stop="toggle"
      @keydown.space.prevent="toggle"
      data-testId="toggle-wrapper"
    >
      <span
        class="toggle-background"
        :class="{ 'toggle-open': this.modelValue, 'toggle-close': !this.modelValue }"
      ></span>
      <span class="toggle-indicator" :style="indicatorStyles"></span>
    </span>
    <p ref="toggleStateAlert"></p>
  </div>
</template>

<script>
import { accessibility } from '@/services/constants'

export default {
  name: 'CustomSwitch',
  props: {
    modelValue: {
      type: Boolean,
      required: true
    }
  },
  emits: ['update:modelValue'],
  mounted() {
    this.setAriaLabelForCheckbox(this.modelValue)
  },
  computed: {
    backgroundStyles() {
      return {
        open: this.modelValue,
        close: !this.modelValue
      }
    },
    indicatorStyles() {
      return { transform: this.modelValue ? 'translateX(20px)' : 'translateX(2px)' }
    }
  },
  methods: {
    setAriaLabelForCheckbox(value) {
      const toggleStateAlert = this.$refs['toggleStateAlert']
      toggleStateAlert?.setAttribute(
        'aria-label',
        `${value ? accessibility.ENABLED : accessibility.DISABLED}`
      )
    },
    toggle() {
      const toggleValue = !this.modelValue
      this.$emit('update:modelValue', toggleValue)
      // cw-accessibility
      this.$refs['toggleStateAlert']?.setAttribute('role', 'alert')
      this.setAriaLabelForCheckbox(toggleValue)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/css/theme.scss';
.toggle-wrapper {
  display: inline-block;
  position: relative;
  cursor: pointer;
  width: 40px;
  height: 20px;
  border-radius: 9999px;
  &:focus {
    outline: 0;
  }

  .toggle-background {
    display: inline-block;
    border-radius: 9999px;
    height: 100%;
    width: 100%;
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: background-color 0.4s ease;
  }

  .toggle-open {
    background-color: #5aa700;
  }

  .toggle-close {
    background-color: #c2c2c2;
  }

  .toggle-indicator {
    position: absolute;
    height: 14px;
    width: 14px;
    left: 2px;
    bottom: 3px;
    background-color: $white-bg;
    border-radius: 9999px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;
  }
}
</style>
